// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Orders_wrapper__2uDgY"};